'use strict';
module.exports = require('../../full/instance/fill');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/fill.js
// module id = 593
// module chunks = 13